export default "__VITE_ASSET__BjGrX8NM__"